var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chooser-component"},[_c('ul',{staticClass:"chooser-list"},_vm._l((_vm.Radios),function(item,index){return _c('li',{class:{'active':_vm.chooseIndex == index},on:{"click":function($event){_vm.choose(index)}}},[_vm._v(_vm._s(item.title))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8f6284","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/details/components/Radios.vue
// module id = null
// module chunks = 